// src/hooks/useInviteCode.ts
import { useState } from 'react';
import { API_BASE_URL } from '../config';

type ValidationResult = {
  success: boolean;
  sessionToken?: string;
  message?: string;
  errorCode?: 'CODE_EXPIRED' | 'CODE_USED' | 'CODE_INVALID';
};

export const useInviteCode = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const validateInviteCode = async (code: string): Promise<ValidationResult> => {
    setIsLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_BASE_URL}/api/invites/validate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ code }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Failed to validate invite code');
      }

      return result;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'An unexpected error occurred';
      setError(errorMessage);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    validateInviteCode,
    isLoading,
    error,
  };
};
